import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { List } from 'immutable';

import { SPORT_URL_NAMES, PRODUCT_ROUTES } from '../../../../constants';

import Tile from '../Tile';

import styles from './MBZeroSportTiles.module.scss';

const MBZeroSportTiles = ({
  tags,
  product,
  navigateFunction,
  size = 'large',
}) => {
  const productUrlPrefix = PRODUCT_ROUTES[product];

  const mbZeroSports = useMemo(() => {
    const horseRacingTag = tags.find(({ urlName }) => urlName === SPORT_URL_NAMES.horseRacing);
    const soccerTag = tags.find(({ urlName }) => urlName === SPORT_URL_NAMES.soccer);

    return new List([
      ...(horseRacingTag ? [horseRacingTag] : []),
      ...(soccerTag ? [soccerTag] : []),
    ]);
  }, [tags]);

  const sectionClass = classNames({
    [styles.sectionContent]: true,
    [styles.paddingSmall]: size === 'small',
    [styles.paddingLarge]: size === 'large',
  });

  return (
    <div className={sectionClass}>
      {mbZeroSports.map(({ urlName, id, name, url }) => (
        <Tile
          key={id}
          name={name}
          iconName={urlName}
          url={`${productUrlPrefix}/events${url}`}
          onClick={navigateFunction}
          flat
        />
      ))}
    </div>
  );
};

MBZeroSportTiles.propTypes = {
  tags: PropTypes.instanceOf(List).isRequired,
  product: PropTypes.string.isRequired,
  navigateFunction: PropTypes.func.isRequired,
  size: PropTypes.string,
};

export default MBZeroSportTiles;
